"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAgentContext = void 0;
var react_1 = __importDefault(require("react"));
var isBrowser = function () { return typeof window !== 'undefined'; };
var userAgent = isBrowser() ? navigator.userAgent : '';
exports.UserAgentContext = react_1.default.createContext(userAgent);
